import React, { useRef, useState } from 'react'

import {
    FormControlLabel,
    Grid,
    makeStyles,
    Typography,
    Switch,
    Box,
    Button,
    Divider,
    Paper,
    Dialog,
    DialogContent
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextValidator } from 'react-material-ui-form-validator';

import { limiteInput } from '../../../../../helpers/limiteInput';
import { useDispatch, useSelector } from 'react-redux';
import { cleanSolic, getSolic } from '../../../../../actions/mesaEntrada/mesaEntradaActions';
import TableGeneric from '../../../../compartidos/abms/TableGeneric';
import { Fragment } from 'react';

const useStyles = makeStyles((theme) => ({
    switchBase: {
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
                backgroundColor: '#3E8040',
                opacity: 1,
                border: 'none',
            },
        },
    },
    checked: {},
    track: {},
}));

export const IntegracionForm = ({ formValues, handleInputChange, setearValor, setearVariosValores, proforma, ospeDirecto, sinRecupero }) => {
    const dispatch = useDispatch();
    const componentRef = useRef();
    const classes = useStyles();

    const { lineasSolicitudes, proformaTomada } = useSelector(state => state.mesaEntrada);
    const [open, setOpen] = useState(false);
    // const [totalFijo, setTotalFijo] = useState(0);

    const disabledValues = formValues.codNom !== "" && formValues.cant !== "" && formValues.importe !== ""

    const disabledBuscar = !formValues.nroAutorizacion || formValues.periodoFacturado.length < 6 || disabledValues;
    const disabledBorrar = formValues.codNom === "" || formValues.cant === "" || formValues.importe === "";

    const handleSearch = () => dispatch(getSolic(formValues.nroAutorizacion, formValues.periodoFacturado, formValues.idTramite, setOpen));

    const Modal = () => (
        <Dialog open={open} fullWidth maxWidth={"md"} component={Paper} elevation={2}>
            <DialogContent>
                <Grid container justify="centern" alignItems="center" spacing={2}>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography variant="button">Listado Solicitudes</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TableGeneric
                            ref={componentRef}
                            data={lineasSolicitudes}
                            withoutPagination
                            align="center"
                            columns={[
                                {
                                    label: "Nro Solicitud",
                                    id: "idSolic"
                                },
                                {
                                    label: "Período",
                                    customBody: () => formValues.periodoFacturado
                                },
                                {
                                    label: "Código Nomenclador",
                                    id: "codNom"
                                },
                                {
                                    label: "Importe",
                                    id: "importe"
                                },
                                {
                                    label: "Cantidad",
                                    id: "cant"
                                },
                                {
                                    customBody: (item) => (
                                        <Button
                                            variant='contained'
                                            color='primary'
                                            onClick={() => {
                                                const total = parseFloat(item.importe).toFixed(2) * parseFloat(item.cant).toFixed(2);
                                                setearVariosValores({
                                                    codNom: item.codNom,
                                                    cantidad: item.cant,
                                                    cantidadModificada: item.cant,
                                                    cantidadFacturada: item.cant,
                                                    valorUnitario: item.importe,
                                                    totalComprobante: parseFloat(total).toFixed(2),
                                                    totalModificado: parseFloat(total).toFixed(2),
                                                });
                                                // setTotalFijo(total);
                                                dispatch(cleanSolic());
                                                setOpen(false);
                                            }}
                                        >
                                            Asignar
                                        </Button>
                                    ),
                                },
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "right", margin: "0.5em" }}>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<CancelIcon />}
                            onClick={() => {
                                setOpen(false);
                                dispatch(cleanSolic());
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )

    return (
        <Fragment>
            {open && (<Modal />)}
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={4}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Id Solicitud"
                    autoComplete="off"
                    name="nroAutorizacion"
                    value={formValues.nroAutorizacion}
                    onChange={handleInputChange}
                    disabled={ospeDirecto || proforma || disabledValues}
                    type='number'
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required",
                        "isNumber",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números",
                    ]}
                />
            </Grid>
            <Grid item xs={4}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Periodo Facturado - YYYY-MM"
                    autoComplete="off"
                    name="periodoFacturado"
                    disabled={ospeDirecto || proforma || disabledValues}
                    value={formValues.periodoFacturado}
                    onChange={e => {
                        limiteInput({
                            e, handleInputChange, setearValor,
                            limit: 6,
                            value: formValues.periodoFacturado,
                            name: "periodoFacturado"
                        })
                    }}
                    type='number'
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required",
                        "isNumber",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números"
                    ]}
                />
            </Grid>
            <Grid item xs={4} style={{ gap: "0.5em", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Button
                    variant='contained'
                    color='primary'
                    disabled={ospeDirecto || disabledBuscar || proforma}
                    onClick={handleSearch}
                >
                    Buscar
                </Button>
                <Button
                    variant='contained'
                    color='secondary'
                    disabled={ospeDirecto || disabledBorrar || proforma}
                    onClick={() => {
                        setearVariosValores({
                            codNom: "",
                            cantidad: "",
                            cantidadModificada: "",
                            cantidadFacturada: "",
                            valorUnitario: "",
                            totalModificado: "",
                            totalComprobante: "",
                            // debito: ""
                        });
                        // setTotalFijo(0);
                    }}
                >
                    Borrar Datos
                </Button>
            </Grid>
            <Grid item xs={4}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Código Práctica"
                    autoComplete="off"
                    name="codNom"
                    disabled
                    value={formValues.codNom}
                    onChange={handleInputChange}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required"
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio"
                    ]}
                />
            </Grid>
            <Grid item xs={4}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Cantidad Facturada"
                    autoComplete="off"
                    name="cantidadFacturada"
                    value={formValues.cantidadFacturada}
                    type='number'
                    onChange={(e) => {
                        const value = e.target.value;
                        const totalFacturado = parseFloat(formValues.valorUnitario) * parseFloat(value);
                        setearVariosValores({
                            cantidadFacturada: value,
                            totalComprobante: totalFacturado ? parseFloat(totalFacturado).toFixed(2) : ""
                        })
                    }}
                    disabled={!formValues.cantidad || proformaTomada}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required",
                        "isFloat",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números decimales",
                    ]}
                />
            </Grid>
            <Grid item xs={4}>
                <Box display='flex' justifyContent='center' alignItems='center'>
                    <Typography variant="button">SURGE</Typography>
                    <FormControlLabel style={{ marginLeft: 5 }} control={
                        <Switch
                            name="recuperoSur"
                            onChange={(e) => { setearValor("recuperoSur", e.target.checked) }}
                            checked={formValues.recuperoSur === "" ? false : formValues.recuperoSur}
                            color="primary"
                            disabled={ospeDirecto || proformaTomada}
                            classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                        />}
                    />
                </Box>
            </Grid>
            <Grid item xs={6}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Cantidad"
                    autoComplete="off"
                    name="cantidad"
                    value={formValues.cantidad}
                    type='number'
                    disabled
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required",
                        "isFloat",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números decimales",
                    ]}
                />
            </Grid>
            <Grid item xs={6}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Valor Unitario"
                    autoComplete="off"
                    name="valorUnitario"
                    value={formValues.valorUnitario}
                    onChange={e => {
                        const value = e.target.value;
                        const totalModificado = parseFloat(formValues.cantidadModificada) * parseFloat(value);
                        // const debitoModificado = totalFijo - totalModificado;
                        setearVariosValores({
                            valorUnitario: value,
                            totalModificado: totalModificado ? parseFloat(totalModificado).toFixed(2) : "",
                            // debito: parseFloat(debitoModificado).toFixed(2)
                        })
                    }}
                    type='number'
                    disabled={formValues.valorUnitario ? false : true}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required",
                        "isFloat",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números decimales",
                    ]}
                />
            </Grid>
            <Grid item xs={6}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Cantidad Modificada"
                    autoComplete="off"
                    name="cantidadModificada"
                    value={formValues.cantidadModificada}
                    onChange={e => {
                        const value = e.target.value;
                        const totalModificado = parseFloat(formValues.valorUnitario) * parseFloat(value);
                        // const debitoModificado = totalFijo - totalModificado;
                        setearVariosValores({
                            cantidadModificada: value,
                            totalModificado: totalModificado ? parseFloat(totalModificado).toFixed(2) : "",
                            // debito: parseFloat(debitoModificado).toFixed(2)
                        })
                    }}
                    type='number'
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    disabled={!formValues.cantidad || proformaTomada}
                    validators={[
                        "required",
                        "isFloat",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números decimales",
                    ]}
                />
            </Grid>
            <Grid item xs={6}>
                <TextValidator
                    variant="outlined"
                    margin='normal'
                    fullWidth
                    label="Total Modificado"
                    autoComplete="off"
                    name="totalModificado"
                    value={formValues.totalModificado}
                    type='number'
                    disabled
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={[
                        "required",
                        "isFloat",
                    ]}
                    errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números decimales",
                    ]}
                />
            </Grid>
        </Fragment>
    )
}
